// extracted by mini-css-extract-plugin
export default {"PopupDialogFrame":"styles_PopupDialogFrame__fThc7","overlay":"styles_overlay__g0tT7","context":"styles_context__HVMfq","content":"styles_content__PEQ8D"};